module.exports = __webpack_public_path__ + "img/flow_blue.590312c6.svg";